import { render } from "./BlogConstructor.vue?vue&type=template&id=0e4008fb&scoped=true"
import script from "./BlogConstructor.vue?vue&type=script&lang=js"
export * from "./BlogConstructor.vue?vue&type=script&lang=js"

import "./BlogConstructor.vue?vue&type=style&index=0&id=0e4008fb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e4008fb"]])

export default __exports__